import { mapIconListForGoogleMap } from '../../consts/mapIconList';
import { getIconIndex } from '../util/formatter';

export const defaultExecutiveMarker = {
  icon: 23,
  color: '#ed1c24',
  style: 'pin'
};

export const getExecutiveMarkerUrl = (entityId, settings = {}) => {
  const marker = settings[entityId];
  if (!marker) return undefined;
  const icon = Number.isInteger(marker.icon)
    ? marker.icon
    : getIconIndex(marker.icon);
  return mapIconListForGoogleMap(
    marker.color || defaultExecutiveMarker.color,
    marker.style || defaultExecutiveMarker.style
  )[icon >= 0 ? icon : defaultExecutiveMarker.icon];
};
